var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _g3, _path11, _path12, _g4, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect2, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _g5, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _g6, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _rect3, _path483, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 90,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6B85D",
    d: "M11.273 84.04h80.465V35.542H11.273z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A49848",
    d: "M89.078 55.768c-2.08 0-3.766-1.888-3.766-4.218 0 1.967-1.204 3.62-2.83 4.088V44.405a.275.275 0 0 0-.275-.275h-.962v-.618a.275.275 0 0 0-.275-.275H56.638a.275.275 0 0 0-.275.275v11.107c-.728-.77-1.182-1.86-1.182-3.07 0 1.294-.52 2.452-1.339 3.226v-10.37a.275.275 0 0 0-.275-.275h-.366v-.618a.276.276 0 0 0-.275-.275H15.26a.274.274 0 0 0-.274.275v12.025c-.388.15-.804.231-1.236.231-.949 0-1.815-.395-2.476-1.045V40.991l2.281-2.73h75.718l2.466 2.95v13.324c-.68.763-1.62 1.233-2.66 1.233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8AE78",
    d: "M82.207 87.267H57.876a.275.275 0 0 1-.276-.275v-.618h23.37a.275.275 0 0 0 .275-.274v-2.061h1.238v2.953a.276.276 0 0 1-.276.275"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M93.48 88.984a.275.275 0 0 1-.275.275H9.623a.275.275 0 0 1-.275-.275v-8.608c0-.153.123-.275.275-.275h83.582c.151 0 .275.122.275.275z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9475",
    d: "M9.348 85.138v3.846c0 .151.123.275.275.275h83.582a.275.275 0 0 0 .275-.275v-3.846z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B38B68",
    d: "M9.348 87.885v1.1c0 .15.123.274.275.274h83.582a.275.275 0 0 0 .275-.275v-1.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2DCC2",
    d: "M93.48 81.978v-1.602a.274.274 0 0 0-.275-.275H9.623a.274.274 0 0 0-.275.275v1.602z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 103,
    height: 4,
    x: 0,
    y: 86,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 86.19h102.828v3.448H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M102.828 89.351a.275.275 0 0 1-.275.275H.275A.275.275 0 0 1 0 89.35V86.65c0-.15.123-.274.275-.274h102.278c.151 0 .275.123.275.274z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 103,
    height: 2,
    x: 0,
    y: 88,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 88.677h102.828v.961H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9475",
    d: "M0 88.801v.55c0 .152.123.275.275.275h102.278a.275.275 0 0 0 .275-.275v-.55z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 103,
    height: 2,
    x: 0,
    y: 86,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 86.19h102.828v1.13H0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2DCC2",
    d: "M102.828 87.153v-.504a.276.276 0 0 0-.275-.274H.275a.275.275 0 0 0-.275.274v.504z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#242023",
    d: "M86.744 24.797a.275.275 0 0 1-.275.274H15.9a.275.275 0 0 1-.274-.274V4.77c0-.15.123-.274.274-.274h70.57c.15 0 .274.123.274.274z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 66,
    height: 19,
    x: 18,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.547.362h65.265v18.546H18.547z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDB0B6",
    d: "M18.715.375h64.9v18.552h-64.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 10,
    x: 24.666,
    y: 4.651,
    fill: "#fff",
    fillOpacity: 0.7,
    rx: 1.409
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M11.269 22.43h80.055v11.269H11.269z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 6,
    x: 34.297,
    y: 24.477,
    fill: "#fff",
    fillOpacity: 0.7,
    rx: 1.409
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A49848",
    d: "M82.483 84.039h-1.238V55.756q.148.012.3.012.486-.001.938-.13z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#978D41",
    d: "M81.545 55.768q-.152 0-.3-.012V44.13h.962c.152 0 .276.123.276.275v11.233q-.452.129-.938.13"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M81.245 86.1a.275.275 0 0 1-.275.274H56.638a.275.275 0 0 1-.275-.274V43.512c0-.152.123-.276.275-.276H80.97c.152 0 .275.124.275.276z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#492628",
    d: "M79.32 86.12c0 .14-.103.254-.232.254H58.52c-.129 0-.232-.113-.232-.254V46.65c0-.14.103-.253.232-.253h20.568c.129 0 .233.114.233.254z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#381F22",
    d: "M58.947 55.768q-.339-.001-.66-.069v-9.048c0-.14.104-.254.233-.254h20.568c.129 0 .233.114.233.254v8.297c-.934-.767-1.543-2.002-1.543-3.398 0 1.403-.61 2.645-1.55 3.412V49.42H61.38v5.35c-.656.624-1.507 1-2.434 1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#25171A",
    d: "M79.32 47.633v-.982c0-.14-.103-.254-.232-.254H58.52c-.128 0-.232.114-.232.254v.982z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#A49848",
    d: "M53.568 76.277H29.246c.234-.205.479-.479.731-.837 0 0 .01-.022.03-.056h22.92a.276.276 0 0 0 .274-.275V55.265q.345-.21.641-.49v21.227a.275.275 0 0 1-.274.275m-26.746 0h-.54l.346-.118.128.043s.023.029.066.075m-.558 0h-1.846l-.101-.135c.03-.28.008-.532-.056-.758h2.683q-.071.122-.117.268s-.134.411-.37.45l.06.02c-.099.06-.187.112-.253.155m-3.877 0H15.9a.275.275 0 0 1-.274-.275v-.431q.312.03.649.029c.686 0 1.432-.088 2.16-.216h3.373c.162.422.362.707.579.893"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#978D41",
    d: "M53.201 55.265V44.13h.366c.151 0 .275.123.275.275v10.37q-.296.28-.641.49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M53.201 75.109a.276.276 0 0 1-.275.275H15.26a.275.275 0 0 1-.274-.275V43.512c0-.152.122-.276.274-.276h37.667c.151 0 .275.124.275.276z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M13.262 55.022s2.313 1.297 2.406 4.43c0 0-2.992-1.245-2.406-4.43"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M12.001 53.445s2.314 1.296 2.406 4.43c0 0-2.992-1.246-2.406-4.43"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M12.162 55.84s2.313 1.295 2.407 4.43c0 0-2.993-1.246-2.407-4.43"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M12.216 49.592s-2.506.866-3.153 3.935c0 0 3.167-.697 3.153-3.935M11.95 53.079s-2.506.866-3.154 3.934c0 0 3.166-.696 3.153-3.934"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M11.291 55.107s-1.817 1.93-.963 4.948c0 0 2.48-2.086.963-4.948M12.418 51.84s2.312 1.295 2.405 4.43c0 0-2.992-1.245-2.405-4.43"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M12.342 49.773s2.48.936 3.041 4.022c0 0-3.146-.785-3.04-4.022M11.935 51.923s-1.71.592-2.153 2.686c0 0 2.162-.475 2.153-2.686"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M12.307 49.339s-1.413 2.242.003 5.04c0 0 2.035-2.523-.003-5.04"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M11.814 53.685s-1.412 2.241.005 5.04c0 0 2.034-2.523-.005-5.04"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M11.56 51.988s-1.6 1.29-1.265 3.698c0 0 2.127-1.34 1.265-3.699M12.697 55.574s1.553 1.345 1.134 3.74c0 0-2.078-1.413-1.134-3.74"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M13.145 47.058s2.313 1.295 2.407 4.429c0 0-2.994-1.245-2.407-4.429"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M11.884 45.48s2.313 1.295 2.407 4.429c0 0-2.994-1.245-2.407-4.429"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M12.045 47.875s2.314 1.294 2.406 4.429c0 0-2.993-1.245-2.406-4.43"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M12.098 41.626s-2.505.866-3.152 3.935c0 0 3.166-.696 3.152-3.935M11.833 45.114s-2.506.865-3.153 3.935c0 0 3.167-.697 3.153-3.935"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M11.174 47.142s-1.816 1.93-.963 4.947c0 0 2.48-2.085.963-4.947M12.3 43.874s2.314 1.296 2.407 4.43c0 0-2.993-1.244-2.407-4.43"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M12.225 41.808s2.482.936 3.042 4.022c0 0-3.146-.784-3.042-4.022M11.818 43.958s-1.71.592-2.152 2.687c0 0 2.162-.476 2.152-2.687"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M12.19 41.373s-1.413 2.242.005 5.04c0 0 2.033-2.522-.005-5.04"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M11.698 45.72s-1.413 2.241.003 5.04c0 0 2.034-2.524-.003-5.04"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M11.442 44.022s-1.599 1.29-1.262 3.698c0 0 2.125-1.341 1.262-3.698M12.58 47.61s1.554 1.343 1.135 3.738c0 0-2.078-1.413-1.135-3.738"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M55.688 54.96s2.314 1.296 2.407 4.431c0 0-2.993-1.245-2.407-4.43"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.428 53.383s2.313 1.295 2.407 4.43c0 0-2.994-1.245-2.407-4.43"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.59 55.777s2.313 1.296 2.406 4.431c0 0-2.993-1.245-2.407-4.43"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M54.643 49.53s-2.506.866-3.152 3.934c0 0 3.165-.697 3.152-3.935M54.376 53.016s-2.505.866-3.153 3.936c0 0 3.167-.697 3.153-3.936"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M53.718 55.045s-1.817 1.93-.964 4.948c0 0 2.48-2.086.964-4.948M54.844 51.778s2.314 1.296 2.407 4.431c0 0-2.993-1.246-2.407-4.43"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.77 49.712s2.48.936 3.04 4.021c0 0-3.145-.785-3.04-4.02M54.362 51.86s-1.711.592-2.153 2.688c0 0 2.163-.475 2.153-2.688"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M54.734 49.276s-1.413 2.243.003 5.042c0 0 2.034-2.524-.003-5.042"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M54.242 53.622s-1.414 2.244.003 5.04c0 0 2.034-2.522-.003-5.04"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M53.986 51.926s-1.6 1.29-1.263 3.698c0 0 2.126-1.34 1.263-3.698M55.123 55.513s1.554 1.344 1.136 3.74c0 0-2.079-1.414-1.136-3.74"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M55.573 46.995s2.313 1.296 2.405 4.43c0 0-2.992-1.245-2.405-4.43"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.312 45.418s2.313 1.296 2.405 4.43c0 0-2.991-1.245-2.405-4.43"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.472 47.812s2.313 1.295 2.407 4.43c0 0-2.993-1.245-2.407-4.43"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M54.526 41.565s-2.506.865-3.153 3.935c0 0 3.167-.697 3.153-3.935M54.26 45.052s-2.506.866-3.153 3.934c0 0 3.166-.696 3.153-3.934"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M53.602 47.08s-1.817 1.93-.964 4.948c0 0 2.48-2.086.964-4.948M54.728 43.813s2.313 1.295 2.406 4.43c0 0-2.993-1.245-2.406-4.43"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M54.652 41.747s2.48.935 3.042 4.021c0 0-3.146-.785-3.042-4.021M54.247 43.896s-1.713.59-2.154 2.686c0 0 2.161-.475 2.153-2.686"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M54.616 41.312s-1.411 2.242.005 5.04c0 0 2.034-2.523-.005-5.04"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M54.125 45.657s-1.413 2.243.003 5.041c0 0 2.035-2.523-.003-5.041"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M53.87 43.96s-1.6 1.291-1.264 3.698c0 0 2.125-1.34 1.264-3.697M55.007 47.547s1.554 1.345 1.135 3.74c0 0-2.078-1.413-1.135-3.74"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M83.903 54.494s2.313 1.296 2.406 4.431c0 0-2.993-1.245-2.406-4.43"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.642 52.918s2.313 1.296 2.407 4.43c0 0-2.994-1.246-2.407-4.43"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.802 55.313s2.314 1.295 2.407 4.429c0 0-2.993-1.245-2.407-4.43"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M82.856 49.065s-2.506.866-3.153 3.935c0 0 3.167-.697 3.153-3.935M82.59 52.552s-2.505.865-3.154 3.934c0 0 3.167-.696 3.154-3.934"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M81.932 54.58s-1.817 1.93-.963 4.948c0 0 2.479-2.086.963-4.947M83.058 51.312s2.312 1.295 2.406 4.43c0 0-2.993-1.244-2.406-4.43"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.983 49.246s2.48.936 3.04 4.022c0 0-3.146-.785-3.04-4.022M82.575 51.396s-1.71.59-2.152 2.687c0 0 2.161-.476 2.152-2.687"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.947 48.812s-1.413 2.241.004 5.04c0 0 2.034-2.522-.004-5.04"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.455 53.156s-1.412 2.243.004 5.041c0 0 2.034-2.523-.005-5.041"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.2 51.46s-1.599 1.29-1.264 3.697c0 0 2.126-1.339 1.264-3.697M83.337 55.047s1.553 1.345 1.134 3.74c0 0-2.078-1.413-1.134-3.74"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M83.785 46.53s2.314 1.295 2.407 4.43c0 0-2.993-1.245-2.407-4.43"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.524 44.953s2.314 1.294 2.407 4.43c0 0-2.993-1.245-2.407-4.43"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.686 47.347s2.313 1.295 2.406 4.43c0 0-2.993-1.246-2.406-4.43"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M82.739 41.099s-2.505.866-3.153 3.934c0 0 3.167-.696 3.153-3.934M82.473 44.587s-2.506.865-3.152 3.934c0 0 3.166-.696 3.152-3.934"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#409841",
    d: "M81.815 46.615s-1.817 1.93-.964 4.947c0 0 2.481-2.086.964-4.947M82.941 43.348s2.313 1.295 2.407 4.43c0 0-2.993-1.245-2.407-4.43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.434,
    height: 10.33,
    x: 60.57,
    y: 70.557,
    fill: "#9B643D",
    fillOpacity: 0.5,
    rx: 1.409
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#37773A",
    d: "M82.866 41.282s2.481.936 3.042 4.02c0 0-3.146-.783-3.042-4.02M82.459 43.43s-1.711.592-2.153 2.688c0 0 2.163-.476 2.153-2.688"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.83 40.846s-1.412 2.243.005 5.041c0 0 2.033-2.523-.004-5.041"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.339 45.191s-1.414 2.243.002 5.041c0 0 2.035-2.522-.002-5.04"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4E2C",
    d: "M82.083 43.494s-1.6 1.291-1.263 3.7c0 0 2.125-1.341 1.263-3.7M83.22 47.083s1.554 1.343 1.136 3.737c0 0-2.079-1.412-1.136-3.737"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#5CA1CD",
    d: "M51.69 73.554a.25.25 0 0 1-.255.248H16.75a.25.25 0 0 1-.253-.248V45.067a.25.25 0 0 1 .253-.248h34.686c.14 0 .255.111.255.248z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#397193",
    d: "M51.435 44.819H16.75a.25.25 0 0 0-.253.248v9.365a4.48 4.48 0 0 0 1.021-2.882c0 2.33 1.685 4.219 3.765 4.219s3.767-1.89 3.767-4.22c0 2.33 1.686 4.22 3.767 4.22s3.766-1.89 3.766-4.22c0 2.33 1.686 4.22 3.766 4.22s3.767-1.89 3.767-4.22c0 2.33 1.687 4.22 3.766 4.22 2.08 0 3.766-1.89 3.766-4.22 0 2.33 1.687 4.22 3.767 4.22q.139-.002.276-.016V45.067a.25.25 0 0 0-.255-.248"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#83B0CD",
    d: "M17.716 70.012a.21.21 0 0 1-.212-.206V51.895a5 5 0 0 0 .013-.345c0 2.33 1.685 4.219 3.765 4.219s3.767-1.89 3.767-4.22c0 2.33 1.686 4.22 3.766 4.22s3.767-1.89 3.767-4.22c0 1.904 1.125 3.515 2.672 4.04zm22.399-18.42v-.042z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B8EA6",
    d: "M28.815 55.769c-2.08 0-3.766-1.89-3.766-4.22 0 2.33-1.687 4.22-3.767 4.22s-3.765-1.89-3.765-4.22q0 .174-.013.346v-5.828a.21.21 0 0 1 .212-.207h28.903a.21.21 0 0 1 .212.207l-6.716 5.524v-.041.041l-4.861 3.997c-1.547-.524-2.672-2.135-2.672-4.038 0 2.33-1.686 4.219-3.767 4.219"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#83B0CD",
    d: "m22.27 67.737 2.114-1.797q-.014.09-.037.198zm2.361-1.818-.095-.108 11.822-10.043c1.721-.005 3.17-1.301 3.614-3.07l.238-.201c.082.4.215.778.39 1.125z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B8EA6",
    d: "m36.359 55.769 3.613-3.072c-.444 1.77-1.892 3.066-3.613 3.072m4.241-2.147a4.5 4.5 0 0 1-.39-1.125l7.813-6.637h2.657z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#5CA1CD",
    d: "M61.38 65.698h14.848v-16.28H61.38z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#397193",
    d: "M61.38 54.766c.815-.774 1.332-1.926 1.332-3.216 0 2.33 1.686 4.218 3.767 4.218s3.767-1.888 3.767-4.218c0 2.33 1.686 4.218 3.766 4.218.829 0 1.593-.303 2.216-.811v-5.538H61.38z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#83B0CD",
    d: "M62.412 62.058v-8.855c.194-.507.3-1.066.3-1.653 0 2.33 1.686 4.219 3.767 4.219s3.767-1.89 3.767-4.22c0 .954.282 1.836.76 2.542z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B8EA6",
    d: "M66.48 55.768c-2.082 0-3.768-1.888-3.768-4.218 0 .587-.106 1.146-.3 1.653v-2.868H75.06l-4.053 3.756a4.53 4.53 0 0 1-.76-2.541c0 2.33-1.687 4.218-3.767 4.218"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#83B0CD",
    d: "m62.412 62.973 8.982-8.39c.327.354.71.642 1.133.846z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B8EA6",
    d: "M72.527 55.428a3.8 3.8 0 0 1-1.134-.845l3.666-3.425v2.383z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M14.972 67.506s-.769 3.922-.025 5.893c0 0 .697-1.035.025-5.893"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M13.486 68.028s.2 3.992 1.397 5.726c0 0 .427-1.172-1.397-5.726"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M12.36 68.763s.972 3.876 2.483 5.344c0 0 .191-1.231-2.482-5.344"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M11.085 69.806s1.917 3.508 3.749 4.549c0 0-.126-1.24-3.75-4.55"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M9.51 71.192s3.12 2.91 5.327 3.352c0 0-.543-1.215-5.327-3.352"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M8.805 72.924s3.849 2.033 6.14 1.877c0 0-.862-1.051-6.14-1.877M7.608 74.028s4.662 1.732 7.234 1.214c0 0-1.132-1.061-7.234-1.214"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M9.056 75.93s3.968.5 5.886-.375c0 0-1.082-.626-5.886.376"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M10.314 77.666s3.267-.708 4.535-1.932c0 0-1.025-.193-4.535 1.932"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M12.73 78.056s1.878-.868 2.115-2.033c0 0-.804-.09-2.114 2.033M16.533 68.292s-.234 3.99-1.447 5.714c0 0-.415-1.176 1.447-5.714"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M17.652 69.036s-1.004 3.867-2.528 5.324c0 0-.18-1.235 2.528-5.324"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M18.918 70.09s-1.946 3.49-3.787 4.517c0 0 .137-1.24 3.787-4.518"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M20.482 71.488s-3.144 2.886-5.356 3.31c0 0 .554-1.213 5.356-3.31"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M21.172 73.226s-3.866 2-6.155 1.826c0 0 .87-1.044 6.155-1.826"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M22.36 74.341s-4.678 1.691-7.244 1.154c0 0 1.14-1.054 7.243-1.154"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M20.895 76.232s-3.971.465-5.88-.427c0 0 1.085-.614 5.88.427"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M19.624 77.955s-3.262-.736-4.52-1.97c0 0 1.028-.184 4.52 1.97"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M17.204 78.25s-1.87-.883-2.098-2.052c0 0 .807-.083 2.098 2.052"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A512E",
    d: "M15.852 83.546c.024-.18-.197-1.183-.197-1.183-.201-.622-.344-3.103-.344-3.103.001-5.303-.292-5.78-.343-6.447v-.096l-.003.048-.004-.047v.095c-.056.666-.269 3.16-.218 6.444 0 0-.165 2.482-.37 3.1 0 0-.168.55-.119.855 0 0 .92-.059 1.328.331 0 0 .113.095.27.003"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M17.598 86.454H12.37l-.576-7.197h6.38z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m18.054 80.763.12-1.506h-6.38l.12 1.506z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M18.581 79.817c0 .076-.06.137-.137.137h-6.92a.137.137 0 0 1-.137-.137v-.895c0-.077.06-.138.137-.138h6.92c.076 0 .137.061.137.138z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB615D",
    d: "M18.581 79.164v-.242a.137.137 0 0 0-.137-.138h-6.92a.14.14 0 0 0-.137.138v.242z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m12.334 86.007.036.447h5.228l.036-.447z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.117 70.792s-.864.388-1.086.634l-.1.219s.675-.572 1.228-.661z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M29.6 68.952s-2.572-.035-2.614 1.942c0 0 1.095 1.399 2.317.12 0 0 .585-.568.928-1.22 0 0 .249-.573.646-.803 0 0-.646.07-1.277-.04"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M28.876 69.918q-.06-.001-.06-.003l.227-.126.046.001c.368 0 1.168-.283 1.168-.283-.656.376-1.203.41-1.38.41M28.698 70.35c-.233 0-.37-.066-.437-.114l.087-.085.06-.014c.126.048.2.117.368.117q.056 0 .128-.012c.048-.008.104-.01.16-.01.284 0 .612.086.612.086a5 5 0 0 0-.364-.015c-.26 0-.378.027-.378.027q-.133.021-.236.02m-.464-.135q-.028-.027-.028-.028l.025-.006q0 .02.003.034"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M28.612 70.82c-.67 0-.757-.369-.757-.369l.093-.053c.02.346.813.374 1.067.374l.078-.001q-.28.051-.48.05"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M28.654 71.299s-.514-.338-.74-.316c-.223.02-.415-.334-.415-.334l-.107.06s.142.295.559.385c0 0 .21-.036.703.205"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M28.793 69.878s.24-.466.905-.825c0 0-.59.473-.718.72z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M28.242 70.252q-.002 0-.008-.038.011.011.027.022zm-.011-.071c-.004-.098.027-.287.238-.532 0 0 .147-.147.35-.544 0 0-.123.407-.297.606-.153.176-.122.274-.149.417l-.025.023z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5025",
    d: "M28.261 70.236q-.016-.011-.026-.022l-.004-.033.117-.03z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M27.833 70.412s-.342-.343.334-1.072c0 0-.548.817-.253 1.027z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.481 69.721s.011.422-.08.546c-.093.121.043.363.043.363l-.073.04s-.122-.19-.024-.464c0 0 .098-.11.134-.485"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M30.548 69.101s-2.214.717-3.562 1.793l.112.117s1.286-.968 3.45-1.91"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M29.654 71.301s-3.703 1.073-2.858 3.471c0 0 2.004.9 2.316-1.477 0 0 .312-1.748.542-1.994"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.504 73.703s.87-1.092 1.945-2.21c0 0-1.163.886-2.12 2.187 0 0-.45.744-.647 1.17l.128.058s.566-1.06.694-1.205"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m28.16 72.916.153-.176c.322-.084 1.005-.605 1.005-.605-.516.564-1.032.743-1.158.781"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m28.13 72.924.17-.182.013-.001q-.08.09-.153.175z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M27.825 73.475a1 1 0 0 1-.126-.011l.127-.154c.062.008.12.019.181.019a.6.6 0 0 0 .284-.078c.286-.147.799-.171.799-.171-.526.122-.74.25-.74.25a1.16 1.16 0 0 1-.525.145"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m27.7 73.464-.05-.012.064-.119.045-.029q.035.002.067.006zm-.085-.025c-.026-.01-.04-.02-.04-.02l.026-.015z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M27.795 74.03a.66.66 0 0 1-.423-.128l.054-.089c.08.082.219.11.376.11.395 0 .915-.186.915-.186-.407.223-.705.294-.922.294"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.372 73.902a.4.4 0 0 1-.07-.07l.046-.05-.015-.006.04-.044c.014.03.031.06.053.081zM28.551 74.504s-.662-.184-.892-.085c-.232.097-.557-.213-.557-.213l-.093.1s.252.265.725.22c0 0 .212-.111.817-.022"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M28.147 72.7a2.75 2.75 0 0 1 .628-.992s-.314.471-.455.81z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M28.095 72.89s.012-.072.052-.19l.173-.182c-.03.075-.054.144-.063.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M27.585 73.35c-.028-.116-.033-.31.088-.59.008 0 .047-.022.12-.467 0 0 .074.242-.044.514a.54.54 0 0 0-.036.384z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.637 73.477s-.01-.012-.022-.038l.035.013zm-.037-.073-.015-.055.128-.158q.012.051.02.108l-.018.034zM27.65 73.452l-.035-.013-.014-.035.113-.07z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M27.245 73.822c-.096-.084-.307-.366.029-1.087 0 0-.235.819.014 1.015z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.284 73.85q-.002.001-.04-.029.026-.04.044-.071.02.017.045.026l-.04.043.01.013z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m27.302 73.832-.01-.013.041-.043.015.006zM26.855 73.398s.145.41.093.56c-.053.15.157.344.157.344l-.06.063s-.178-.148-.169-.45c0 0 .062-.138-.02-.517M25.623 74.926s.615.505 1.06-.077l.127.06s-.443.711-1.175.25zM25.685 76.651s.387-.193 1.225-.875l-.01.19s-.812.783-1.246.869z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M29.511 74.33s-.691-.045-1.121.18c0 0-1.258.157-1.563 1.142 0 0-.134.411-.37.45l.298.1s1.408 1.812 3.222-.762c0 0 .314-.695 1.047-.623 0 0-1.25-.505-1.513-.487"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.847 75.54s1.234-.418 2.654-.757c0 0-1.393.118-2.796.656 0 0-1.104.62-1.462.85l.47-.16c.718-.404.697-.464 1.134-.59"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M29.323 75.316c-.288 0-.49-.045-.562-.063l.21-.062c.123.035.323.046.522.046.308 0 .61-.026.61-.026-.297.08-.562.105-.78.105"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m28.76 75.253-.028-.008.227-.058.011.004z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M29.488 75.825c-.507-.158-.75-.165-.75-.165-.335-.029-.522-.131-.617-.21l.178-.056c.111.08.19.16.426.178.31.025.763.253.763.253"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M28.12 75.45q-.02-.017-.037-.033l.11-.06h.051l.055.037zm-.061-.059c-.017-.02-.024-.034-.024-.034h.027z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M28.875 76.15c-.931-.052-1.176-.385-1.24-.542l.093-.032c.096.362 1.147.574 1.147.574"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.636 75.609a.4.4 0 0 1-.02-.069l.06-.015q-.004-.006-.01-.011l.056-.014a.2.2 0 0 0 .006.076q-.05.015-.092.033M28.39 76.658s-.486-.46-.729-.496c-.241-.035-.384-.43-.384-.43l-.124.031s.099.325.526.518c0 0 .23.017.712.377"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M28.847 75.08a2.5 2.5 0 0 1 .979-.458s-.478.211-.751.403z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M28.717 75.202s.041-.05.13-.121q.117-.03.228-.055a.8.8 0 0 0-.143.12zM28.061 75.43q-.001 0-.002-.039l.024.026z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M28.073 75.306c.028-.1.11-.252.338-.409l.004.001c.015 0 .073-.025.308-.3 0 0-.045.22-.268.373a.43.43 0 0 0-.201.277q-.09.027-.181.058"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M28.192 75.357h-.13l.01-.05.182-.059q-.014.044-.033.093zM28.084 75.417l-.025-.026q.002-.014.003-.034h.13z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M27.575 75.512c-.046-.101-.118-.425.505-.824 0 0-.572.518-.439.787q-.03.016-.066.037"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M27.592 75.546q-.002.001-.017-.034l.066-.037a.3.3 0 0 0 .025.039l-.052.012.001.014z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m27.616 75.54-.002-.014.052-.012q.006.006.01.012zM27.425 74.994s-.059.383-.17.473c-.113.09-.017.34-.017.34l-.08.02s-.088-.2.055-.426c0 0 .114-.078.212-.407"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M24.397 65.658s2.71 2.741.804 4.423c0 0-2.19-.19-1.304-2.417 0 0 .58-1.679.5-2.006"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M25.103 68.804s-.228-1.38-.621-2.878c0 0 .584 1.34.784 2.943 0 0 .03.87-.004 1.337l-.14-.012s.021-1.2-.02-1.39"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M24.914 67.797c-.093-.094-.456-.503-.63-1.248 0 0 .343.79.582 1.02q.026.119.048.228"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m24.935 67.817-.021-.02q-.023-.11-.048-.229l.01.01zM25.17 68.52l-.036-.001.03-.024.015.025z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M25.05 68.5c-.12-.04-.31-.146-.503-.434 0 0-.126-.217-.525-.58 0 0 .436.272.614.539.135.202.247.226.377.277z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m25.097 68.511-.047-.012-.037-.197.06.028.026.047z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M25.039 69.047c-.214 0-.585-.123-1.012-.805 0 0 .615.706 1.01.706a.3.3 0 0 0 .08-.011l.004.104a1 1 0 0 1-.082.006"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m25.121 69.041-.004-.104a.24.24 0 0 0 .085-.045l.014.06q-.008-.004-.015-.004l.015.066a.4.4 0 0 1-.095.027M23.798 68.993s.668.162.822.359c.152.199.588.086.588.086l.033.132s-.35.11-.74-.16c0 0-.131-.2-.703-.417"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M25.03 67.612q-.03-.124-.062-.241c.042-.365 0-.928 0-.928.136.527.104.942.062 1.17"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m24.984 67.807-.058-.232q.028-.081.043-.205l.061.242c-.022.126-.047.195-.047.195M25.097 68.54v-.029q.021.005.037.007-.036.024-.037.022"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m25.206 68.455-.035-.2c.07-.083.136-.159.155-.354a.8.8 0 0 1 .212-.47c-.167.462-.124.466-.123.466-.03.304-.13.47-.21.558"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m25.164 68.494-.065-.117v-.037q.036-.046.072-.085l.035.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M25.134 68.518q-.016-.001-.037-.007l.002-.134.066.118z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m25.271 69.032-.002-.083c.312-.05.507-.88.507-.88-.058.794-.381.938-.505.963"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M25.224 69.038h-.001l-.006-.024.014-.007-.014-.056h.022q.015 0 .03-.002l.002.083a.3.3 0 0 1-.047.006"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m25.217 69.014-.016-.066.016.003.014.056zM25.818 68.852s-.327.289-.353.445c-.029.157-.306.223-.306.223l.02.084s.23-.043.368-.31c0 0 .014-.15.27-.442M26.15 70.786s-.784.143-.888-.58l-.14-.012s.039.836.903.79zM25.777 72.507s-.288-.323-.815-1.265l-.06.178s.464 1.028.836 1.269z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M23.08 68.936s.66.213.976.583c0 0 1.11.61 1.029 1.637 0 0-.027.431.176.554l-.312-.017s-1.979 1.163-2.714-1.898c0 0-.032-.762-.74-.966 0 0 1.349-.006 1.585.107"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M24.18 70.675s-.993-.845-2.188-1.683c0 0 1.253.624 2.356 1.642 0 0 .537.593.784.94l-.118.068s-.69-.856-.834-.967"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M23.436 70.072c-.128-.018-.657-.108-1.232-.537 0 0 .734.369 1.061.4z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.466 70.074-.03-.002q-.082-.067-.17-.136l.01.001z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M23.716 70.525c-.11 0-.245-.017-.41-.068 0 0-.228-.084-.758-.123 0 0 .123-.01.283-.01.166 0 .37.011.52.057a.8.8 0 0 0 .217.037c.094 0 .164-.025.245-.046l.144.119a.8.8 0 0 1-.24.034"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.957 70.49-.143-.117q.03-.008.064-.015l.048.02.078.095a.2.2 0 0 1-.047.018m.08-.032.01-.033.025.011q0 .002-.035.022"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M23.772 71.01c-.196 0-.448-.04-.773-.148 0 0 .33.06.66.06.253 0 .507-.035.61-.16q.03.03.065.07c-.08.077-.248.178-.562.178"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M24.334 70.832q-.035-.04-.065-.07a.2.2 0 0 0 .042-.078l.046.033-.015.008.052.036a.3.3 0 0 1-.06.07M23.26 71.514s.623-.249.862-.192c.237.056.515-.258.515-.258l.104.075s-.21.267-.68.285c0 0-.22-.068-.8.09"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m23.42 69.879-.192-.136c-.18-.28-.548-.652-.548-.652.42.295.637.605.74.788"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.497 70.04-.181-.131a1 1 0 0 0-.088-.166q.095.065.192.136c.056.1.077.16.077.16"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m24.055 70.375-.145-.12a.44.44 0 0 0-.086-.333c-.15-.223-.11-.445-.11-.445.127.372.168.393.177.393h.001c.155.23.174.401.163.505"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m24.021 70.494-.017-.021.033-.015q-.014.036-.016.036m.026-.069-.121-.047-.022-.027q0-.052.006-.097l.145.121zM24.004 70.473l-.078-.095.12.047-.01.033z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m24.448 70.746-.05-.057c.217-.204-.12-.893-.12-.893.423.589.253.864.17.95"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m24.413 70.775-.02-.014.008-.011-.044-.033a.2.2 0 0 0 .04-.028q.023.023.051.057c-.02.02-.035.03-.035.03"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m24.394 70.761-.052-.036.015-.008.045.033zM24.774 70.324s-.088.378-.017.504c.07.125-.11.32-.11.32l.065.047s.157-.151.108-.414c0 0-.078-.114-.046-.457M24.716 73.564s.651.686.763.996l.01.242s-.408-.786-.886-1.079z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M23.118 70.918s2.394.943 1.68 2.787c0 0-1.545.88-2.19-.766 0 0-.325-.75-.394-1.482 0 0-.012-.625-.293-.989 0 0 .572.312 1.197.45"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M23.476 72.108s-.61-.197-1.178-.926c0 0 .69.617 1.017.721zM23.75 72.626c-.123 0-.305-.036-.54-.181 0 0-.194-.136-.684-.292 0 0 .486.062.744.222a.54.54 0 0 0 .394.094q.043-.003.089-.004h.018l.048.037.05.11a.5.5 0 0 1-.12.014m.151-.022.016-.03.02.016q0 .002-.036.014"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M23.764 73.122c-.199 0-.481-.075-.869-.33 0 0 .52.235.882.235.146 0 .267-.037.318-.144l.066.084s-.111.155-.397.155"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M23.101 73.449s.603-.118.803-.014.513-.15.513-.15l.075.096s-.243.219-.664.144c0 0-.18-.113-.727-.076"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m23.51 72.08-.13-.166c-.025-.279-.392-.94-.392-.94.479.584.523 1.106.523 1.106"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m23.879 72.636-.01-.023q.018-.003.032-.01zm.038-.062-.098-.072-.013-.03c.03-.143.095-.222.02-.442-.085-.251-.044-.676-.044-.676.037.446.115.638.115.638.105.307.06.494.02.582"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5025",
    d: "m23.868 72.613-.05-.11.099.071q-.008.018-.016.03z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m24.198 72.94-.06-.073c.354-.081.157-1.046.157-1.046.35.932-.098 1.12-.098 1.12"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M24.785 72.434s-.172.386-.132.535-.18.319-.18.319l.054.065s.184-.13.197-.42c0 0-.047-.14.06-.499"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M22.184 70.696s1.776 1.504 2.613 3.009l-.147.068s-.822-1.385-2.466-3.077"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M20.843 73.366s3.838.358 3.46 2.872c0 0-1.798 1.26-2.551-1.015 0 0-.637-1.659-.909-1.857"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M23.406 75.322s-1.06-.91-2.324-1.805c0 0 1.307.65 2.492 1.75 0 0 .583.645.856 1.026l-.115.083s-.755-.935-.909-1.054"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M22.614 74.67c-.131-.012-.672-.091-1.283-.549 0 0 .769.384 1.1.407q.096.073.183.143"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m22.645 74.674-.03-.003-.183-.143h.012z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M22.887 75.172c-.104 0-.23-.016-.38-.06 0 0-.235-.084-.775-.106 0 0 .191-.027.409-.027.139 0 .288.01.407.047a.8.8 0 0 0 .2.032c.107 0 .18-.034.269-.061l.154.126a.8.8 0 0 1-.284.05"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.17 75.123-.153-.127.063-.019.05.02.086.105q-.021.01-.045.02m.077-.04q.006-.016.008-.037l.028.01q0 .001-.036.027"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M22.955 75.718c-.19 0-.429-.038-.732-.136 0 0 .264.042.557.042s.612-.042.724-.209l.07.076c-.083.095-.26.227-.619.227"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.574 75.491-.07-.076a.2.2 0 0 0 .036-.089l.05.035-.015.01.055.039a.4.4 0 0 1-.056.081M22.53 76.305s.614-.306.86-.253c.244.052.506-.312.506-.312l.11.08s-.198.308-.67.352c0 0-.229-.07-.806.133"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M22.585 74.455q-.104-.076-.203-.144c-.202-.308-.597-.711-.597-.711.444.314.685.655.8.855"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m22.675 74.634-.193-.14a1 1 0 0 0-.1-.184l.203.145c.064.11.09.179.09.179"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m23.26 74.988-.154-.13a.54.54 0 0 0-.108-.37c-.167-.246-.142-.497-.142-.497.152.41.197.435.206.435.173.253.204.444.199.562"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.234 75.124-.018-.022.032-.019c-.007.027-.015.04-.015.04m.022-.078-.125-.049-.024-.029a1 1 0 0 1 0-.11l.154.13a.4.4 0 0 1-.005.058"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.216 75.102-.085-.104.125.048q-.004.02-.009.037z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m23.684 75.39-.056-.063c.207-.24-.177-1-.177-1 .465.645.31.963.233 1.063"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.65 75.425-.02-.015.007-.014-.048-.035a.2.2 0 0 0 .039-.034l.055.063c-.019.022-.033.035-.033.035"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m23.63 75.41-.055-.04.014-.009.048.035zM23.986 74.9s-.064.43.015.567c.08.138-.09.367-.09.367l.07.051s.148-.18.081-.473c0 0-.085-.124-.076-.512M25.485 76.168s-.51.612-1.055.125l-.115.083s.569.614 1.2.025z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#225E2C",
    d: "M26.11 71.016q-.04-.01-.082-.022c-.623 2.668-1.237 6.967.593 9.079l.104-.225s-1.886-2.422-.614-8.832"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M26.696 65.824s-.403.485-.465.949c0 0-.554 1.034.017 1.887 0 0 .235.36.138.56l.233-.158s2.1.105 1.153-2.878c0 0-.35-.676.093-1.174 0 0-1.043.608-1.17.814"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.774 67.852s.314-1.193.785-2.476c0 0-.625 1.127-.935 2.52 0 0-.525 2.622-.599 3.088l.006.442s.69-3.41.743-3.574"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m27.024 66.983.06-.196c.231-.183.597-.847.597-.847-.216.64-.568.968-.657 1.043"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m27.003 67 .072-.207.009-.006-.06.196z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m26.846 67.59.048-.17c.12-.035.22-.046.355-.214.178-.219.584-.423.584-.423-.38.288-.51.467-.51.467-.194.238-.368.316-.477.34"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.76 67.6q-.03-.001-.03-.002l.016-.021.024.022zm.042-.003.01-.119.027-.039.055-.02-.049.17q-.023.007-.043.008"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M26.857 68.075a.4.4 0 0 1-.13-.019l.019-.089q.046.02.104.02c.35 0 .916-.538.916-.538-.398.518-.715.626-.909.626"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.726 68.057a.3.3 0 0 1-.07-.029l.02-.056h-.014l.017-.05a.2.2 0 0 0 .067.046zM27.904 68.127s-.598.088-.75.248c-.151.163-.526.027-.526.027l-.04.114s.298.125.665-.08c0 0 .13-.165.651-.309"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M26.937 66.812a2.4 2.4 0 0 1 .152-1.023s-.084.491-.078.815q-.038.102-.074.208"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.961 66.986s-.016-.063-.024-.174q.036-.106.074-.208a1 1 0 0 0 .02.184z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M26.712 67.538c-.061-.084-.135-.239-.138-.508.002 0 .038-.006-.067-.42 0 0 .144.17.145.431a.48.48 0 0 0 .109.324q-.026.086-.049.173"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m26.8 67.623-.03-.024q.014 0 .032-.002zm-.054-.046-.034-.039q.023-.087.049-.173.026.036.053.08l-.002.033z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m26.77 67.6-.024-.023.066-.099-.01.12z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M26.597 68.037c-.113-.04-.368-.205-.354-.885 0 0 .1.736.369.815z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.649 68.049s-.02-.001-.052-.012l.015-.07q.022.006.046.006h.004l-.017.048q0 .001.012.007z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M26.657 68.028q-.014-.006-.012-.007l.017-.048.014-.001zM26.141 67.837s.263.28.274.42c.012.141.25.222.25.222l-.026.071s-.197-.055-.296-.303c0 0 0-.132-.202-.41"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M28.595 86.425h-5.228l-.577-7.195h6.382z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m29.051 80.735.121-1.505H22.79l.12 1.505z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M29.577 79.789c0 .075-.06.137-.137.137h-6.919a.14.14 0 0 1-.137-.138v-.895c0-.076.062-.137.137-.137h6.92c.075 0 .136.061.136.137z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB615D",
    d: "M29.577 79.136v-.243a.136.136 0 0 0-.137-.137h-6.919a.137.137 0 0 0-.137.137v.243z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m23.331 85.978.036.447h5.228l.036-.447z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 3,
    height: 3,
    x: 34,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.202 72.036h2.474v2.852h-2.474z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 3,
    height: 3,
    x: 34,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.19 72.32c-.302.333-1.185 2.823-.903 2.475.569-.699 1.8-1.047 2.103-1.38a.811.811 0 0 0-1.2-1.094"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 3,
    height: 3,
    x: 34,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.19 72.32c-.302.333-1.185 2.822-.903 2.475.569-.699 1.8-1.048 2.103-1.38a.811.811 0 0 0-1.2-1.095"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 4,
    height: 5,
    x: 33,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.992 71.995-2.963-.282-.325 3.4 2.963.284z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m36.963 72.064-2.739-.262-.308 3.23 2.738.26z"
  })))))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M32.718 70.715c.28.268 1.429 1.828 1.042 1.798-.67-.05-1.73-.516-2.01-.782a.7.7 0 1 1 .968-1.016M32.37 72.528c.908.448 2.152 2.286 1.668 2.162-2.016-.514-2.236-.371-2.655-.644a.905.905 0 0 1-.267-1.252c.273-.42.805-.487 1.254-.266"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M32.205 71.117s.126.053.304.155c.18.1.404.255.621.42.106.087.205.183.302.267.092.09.166.186.235.262.064.082.103.16.137.209l.047.081-.233-.245c-.15-.136-.348-.316-.562-.48-.105-.085-.208-.171-.31-.245l-.274-.213zM31.856 73.14s.169.051.41.158c.12.053.26.116.406.194.147.072.295.167.445.256.149.095.29.202.423.299.128.104.237.215.335.303.05.044.084.097.117.138l.086.11.071.096-.094-.076q-.043-.039-.103-.09c-.042-.033-.083-.076-.134-.114q-.16-.114-.36-.259c-.136-.085-.275-.188-.423-.277-.589-.37-1.179-.737-1.179-.737"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M32.452 74.555c.908.448 2.152 2.287 1.667 2.163-2.015-.514-2.235-.372-2.654-.645a.903.903 0 0 1-.266-1.251c.273-.42.805-.487 1.253-.267"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M31.94 75.167s.168.051.409.158c.12.053.26.116.404.194.148.072.296.167.446.257.15.094.29.202.422.298.13.104.238.216.335.303.05.045.084.098.118.139l.087.109.07.097-.093-.077-.104-.09c-.042-.032-.083-.075-.135-.114l-.358-.258c-.138-.085-.276-.188-.424-.278z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M32.733 76.889c.808.398 1.914 2.033 1.483 1.923-1.792-.458-1.988-.332-2.362-.573a.807.807 0 0 1-.236-1.115c.242-.373.717-.432 1.115-.235"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M32.277 77.434s.15.044.363.139c.107.048.232.103.36.172.133.065.264.15.398.229.132.084.258.18.374.266.116.092.212.191.3.269.043.039.074.086.104.123l.076.097.063.086s-.122-.101-.295-.249l-.318-.23c-.124-.076-.246-.167-.377-.247z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M35.92 71.023c-1.683 1.187-2.064 1.923-2.07 1.406-.02-1.194.169-1.82.409-2.277a.94.94 0 0 1 1.267-.393c.458.24.817.966.394 1.264"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m35.41 70.072-.832 1.1c-.105.136-.197.28-.295.408q-.132.205-.24.367c-.12.223-.209.377-.209.377l.032-.115q.018-.054.04-.132c.018-.05.032-.11.061-.17.06-.116.122-.257.204-.4.088-.138.18-.285.285-.426.108-.136.212-.277.323-.396.108-.124.214-.232.307-.323.186-.184.324-.29.324-.29"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M36.661 77.916c-1.964.615-2.552 1.2-2.4.705.347-1.14.717-1.68 1.087-2.043a.94.94 0 0 1 1.326.013c.363.369.482 1.17-.013 1.325"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m36.468 76.854-1.129.793c-.14.097-.273.207-.406.299l-.34.275c-.184.176-.315.296-.315.296l.066-.1.08-.113c.03-.043.063-.096.108-.144.092-.092.195-.206.317-.318.126-.104.26-.217.401-.318.145-.097.286-.2.429-.28.14-.084.275-.154.392-.213.233-.118.397-.177.397-.177M35.81 72.577l-.832 1.1c-.105.136-.196.28-.294.408-.089.133-.17.26-.241.366l-.15.273-.06.104.033-.115q.018-.055.04-.13c.017-.052.032-.112.06-.172.06-.115.123-.256.204-.399.088-.138.182-.286.286-.425.108-.137.21-.279.323-.398.106-.123.215-.231.307-.323.186-.183.324-.29.324-.29"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M35.19 72.32c-.302.333-1.185 2.823-.903 2.475.569-.699 1.8-1.047 2.103-1.38a.811.811 0 0 0-1.2-1.094"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m35.81 72.577-.832 1.1c-.105.136-.196.28-.294.408-.089.133-.17.26-.241.366l-.15.273-.06.104.033-.115q.018-.055.04-.13c.017-.052.032-.112.06-.172.06-.115.123-.256.204-.399.088-.138.182-.286.286-.425.108-.137.21-.279.323-.398.106-.123.215-.231.307-.323.186-.183.324-.29.324-.29"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M35.609 74.352c-.34.289-1.537 2.646-1.212 2.337.653-.62 1.92-.81 2.262-1.098a.812.812 0 1 0-1.05-1.239"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m36.192 74.684-.967.985c-.121.12-.232.251-.345.366l-.285.333c-.149.207-.257.348-.255.348l.046-.11.058-.126c.022-.048.044-.105.08-.16.075-.107.154-.24.254-.371.104-.125.215-.26.337-.385.125-.122.245-.248.371-.353.122-.108.242-.202.346-.281a4 4 0 0 1 .36-.246"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M33.424 70.24s1.778 7.508.078 11.3c0 0-.073.163.203.11 0 0 1.805-2.68-.28-11.41"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M33.516 68.379c.16.435.285 2.757-.014 2.402-.398-.475-1.406-1.386-1.567-1.822a.843.843 0 0 1 1.581-.58"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M32.574 68.397s.093.137.213.352c.058.11.13.234.198.373.067.138.138.287.205.436.066.151.127.305.182.45.058.143.094.284.13.403.04.116.049.223.062.294l.016.11-.04-.105c-.024-.068-.056-.164-.107-.276a18 18 0 0 0-.165-.385c-.06-.14-.126-.29-.196-.438a14 14 0 0 0-.19-.443c-.06-.14-.113-.274-.16-.387a11 11 0 0 1-.148-.385"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D3035",
    d: "M36.185 86.424h-4.99l-.55-5.99h6.09z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#332125",
    d: "m36.62 81.69.115-1.255h-6.09l.116 1.254z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D3035",
    d: "M37.122 80.9c0 .064-.059.116-.13.116H30.39c-.073 0-.133-.052-.133-.116v-.743c0-.065.06-.115.133-.115h6.602c.071 0 .13.05.13.115z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#684348",
    d: "M37.122 80.359v-.202c0-.065-.059-.115-.13-.115H30.39c-.073 0-.133.05-.133.115v.202z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#332125",
    d: "m31.162 86.052.034.372h4.989l.033-.372z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.403 76.824s-2.49-1.4-3.347-3.614c0 0 2.884 2.792 3.347 3.614M45.412 75.995s-2.359-1.61-3.018-3.891c0 0 2.629 3.033 3.017 3.891M45.334 74.884s-2.359-1.61-3.018-3.891c0 0 2.63 3.032 3.018 3.89M45.303 73.923s-2.319-1.667-2.923-3.963c0 0 2.555 3.095 2.923 3.963M45.06 72.833s-2.184-1.84-2.612-4.175c0 0 2.312 3.281 2.612 4.175"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.17 72.325s-1.984-2.056-2.167-4.421c0 0 1.96 3.502 2.166 4.42M45.157 71.038s-1.886-2.143-1.962-4.516c0 0 1.798 3.587 1.962 4.516M45.09 69.507s-1.782-2.233-1.74-4.606c0 0 1.62 3.67 1.74 4.606M44.954 67.12s-1.472-2.446-1.12-4.795c0 0 1.125 3.853 1.12 4.796"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M44.897 67.17s1.782-2.232 1.742-4.605c0 0-1.623 3.67-1.742 4.605M44.854 65.482s1.015-1.759.735-3.424c0 0-.751 2.753-.735 3.424M45.065 69.2s2.093-1.943 2.406-4.297c0 0-2.149 3.39-2.406 4.298"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.018 68.21s2.09-1.945 2.404-4.297c0 0-2.148 3.389-2.404 4.297M45.134 70.343s2.09-1.944 2.404-4.298c0 0-2.15 3.389-2.404 4.298"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.13 71.234s2.093-1.943 2.404-4.297c0 0-2.148 3.39-2.405 4.297M45.248 72.37s2.091-1.944 2.404-4.3c0 0-2.147 3.391-2.404 4.3M45.208 73.694s2.092-1.943 2.404-4.297c0 0-2.147 3.39-2.404 4.297M45.438 74.334s2.23-1.786 2.714-4.11c0 0-2.392 3.224-2.714 4.11M45.483 75.494s2.23-1.785 2.715-4.11c0 0-2.39 3.223-2.715 4.11"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.51 76.416s2.23-1.787 2.713-4.11c0 0-2.391 3.223-2.713 4.11"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.472 77.11s2.228-1.784 2.713-4.109c0 0-2.391 3.223-2.713 4.11"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m45.314 78.653-.056-2.358c-.04-1.415-.093-3.3-.172-5.187-.034-.944-.08-1.886-.127-2.769-.026-.441-.04-.87-.073-1.274-.027-.403-.055-.786-.08-1.139-.028-.353-.039-.678-.078-.963q-.046-.43-.081-.74l-.072-.644.088.642.102.738c.046.284.065.61.104.96q.05.532.11 1.14c.041.403.067.83.104 1.271.07.883.141 1.825.2 2.767.13 1.885.232 3.77.308 5.184l.118 2.358zM44.526 77.78s-1.852.022-3.05-.944c0 0 2.524.633 3.05.944M44.261 77.314s-1.846-.14-2.955-1.207c0 0 2.458.85 2.955 1.207M43.857 76.715s-1.846-.14-2.955-1.206c0 0 2.458.85 2.955 1.206M43.528 76.186s-1.84-.184-2.925-1.277c0 0 2.437.909 2.925 1.277M43.038 75.652s-1.821-.324-2.82-1.496c0 0 2.36 1.091 2.82 1.496"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M42.935 75.331s-1.779-.51-2.65-1.777c0 0 2.236 1.329 2.65 1.777M42.51 74.614s-1.753-.591-2.565-1.898c0 0 2.172 1.43 2.564 1.898M41.976 73.777s-1.723-.676-2.47-2.02c0 0 2.1 1.534 2.47 2.02M41.126 72.482s-1.619-.896-2.183-2.327c0 0 1.88 1.796 2.183 2.327"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M41.11 72.528s.275-1.829-.517-3.148c0 0 .28 2.584.518 3.148M40.538 71.595s0-1.316-.698-2.16c0 0 .471 1.79.698 2.16M41.863 73.613s.544-1.767-.045-3.19c0 0-.105 2.598.045 3.19"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M41.515 73.073s.542-1.769-.045-3.19c0 0-.106 2.597.045 3.19M42.271 74.231s.544-1.768-.045-3.188c0 0-.105 2.596.045 3.188"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M42.559 74.734s.543-1.769-.045-3.19c0 0-.106 2.597.045 3.19M42.994 75.331s.542-1.768-.046-3.19c0 0-.106 2.598.046 3.19M43.4 76.088s.543-1.768-.045-3.19c0 0-.104 2.597.045 3.19M43.737 76.372s.671-1.723.19-3.184c0 0-.297 2.582-.19 3.184M44.14 77.008s.67-1.724.19-3.185c0 0-.298 2.583-.19 3.185"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M44.452 77.517s.672-1.724.19-3.185c0 0-.297 2.582-.19 3.185"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M44.657 77.92s.67-1.724.189-3.186c0 0-.296 2.583-.19 3.185"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M45.068 78.836s-1.265-2.094-2.575-4.16a91 91 0 0 0-.97-1.512c-.308-.483-.61-.925-.868-1.305-.13-.188-.242-.367-.356-.514l-.285-.389-.25-.339.555.714c.118.145.234.32.37.505.266.374.58.807.901 1.283.327.473.671.978 1.011 1.488a261 261 0 0 1 2.685 4.094zM46.466 76.906S45.119 75.1 45.21 73.23c0 0 1.185 2.934 1.255 3.675M46.738 76.312s-1.184-1.916-.93-3.77c0 0 .924 3.025.93 3.77M47.038 75.485s-1.185-1.915-.931-3.769c0 0 .925 3.026.931 3.769M47.322 74.782s-1.138-1.94-.84-3.789c0 0 .853 3.046.84 3.789M47.496 73.919s-.987-2.023-.547-3.844c0 0 .616 3.104.547 3.843"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M47.738 73.588s-.773-2.114-.15-3.879c0 0 .295 3.149.15 3.88M48.14 72.656s-.675-2.148.028-3.882c0 0 .151 3.16-.028 3.882M48.58 71.53s-.569-2.177.218-3.874c0 0-.005 3.162-.218 3.875M49.245 69.768s-.278-2.234.727-3.814c0 0-.421 3.135-.727 3.814"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M49.189 69.785s1.997-1.04 2.727-2.763c0 0-2.341 2.126-2.727 2.763M49.697 68.555s1.294-.943 1.625-2.234c0 0-1.422 1.745-1.626 2.234M48.662 71.302s2.13-.733 3.107-2.329c0 0-2.633 1.757-3.107 2.33"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M48.943 70.573s2.128-.734 3.107-2.33c0 0-2.633 1.757-3.107 2.33M48.345 72.146s2.129-.733 3.107-2.328c0 0-2.633 1.757-3.107 2.328"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M48.057 72.788s2.13-.733 3.107-2.328c0 0-2.633 1.755-3.107 2.328M47.78 73.645s2.13-.734 3.107-2.331c0 0-2.632 1.758-3.107 2.33M47.327 74.586s2.13-.733 3.107-2.328c0 0-2.631 1.757-3.107 2.328M47.289 75.122s2.177-.576 3.27-2.096c0 0-2.754 1.56-3.27 2.096M46.95 75.97s2.179-.573 3.271-2.093c0 0-2.754 1.559-3.27 2.094"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M46.674 76.644s2.178-.575 3.27-2.095c0 0-2.754 1.56-3.27 2.095"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M46.424 77.133s2.178-.574 3.27-2.095c0 0-2.753 1.56-3.27 2.095"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m45.818 78.195.714-1.718c.424-1.032.99-2.41 1.535-3.794.277-.69.544-1.384.792-2.037.122-.325.25-.638.356-.94l.306-.847c.092-.263.189-.5.252-.719l.177-.558.155-.488-.142.491-.163.565c-.058.22-.148.46-.233.724l-.284.857c-.098.304-.217.62-.331.95-.231.658-.482 1.36-.74 2.058-.51 1.4-1.039 2.792-1.436 3.835l-.669 1.738z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M48.32 86.32h-5.642l-.622-7.763h6.885z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m48.811 80.181.13-1.624h-6.885l.13 1.624z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M49.38 79.16a.15.15 0 0 1-.15.148h-7.463a.15.15 0 0 1-.149-.148v-.965c0-.081.067-.148.149-.148h7.463c.083 0 .15.067.15.148z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB615D",
    d: "M49.38 78.457v-.262a.15.15 0 0 0-.15-.148h-7.463a.15.15 0 0 0-.149.148v.262z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m42.64 85.837.038.483h5.641l.038-.483z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M84.794 67.37s-.768 3.922-.024 5.894c0 0 .697-1.036.024-5.894"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M83.308 67.894s.2 3.991 1.399 5.725c0 0 .426-1.172-1.399-5.725"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M82.182 68.628s.972 3.876 2.483 5.345c0 0 .192-1.232-2.483-5.345"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M80.908 69.67s1.915 3.509 3.75 4.55c0 0-.127-1.241-3.75-4.55"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M79.333 71.056s3.12 2.912 5.327 3.353c0 0-.544-1.214-5.327-3.353"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M78.628 72.788s3.85 2.034 6.139 1.877c0 0-.86-1.05-6.14-1.877"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M77.431 73.893s4.662 1.731 7.234 1.214c0 0-1.132-1.061-7.234-1.214"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M78.879 75.796s3.968.5 5.884-.376c0 0-1.08-.626-5.885.376"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M80.136 77.53s3.268-.708 4.536-1.931c0 0-1.026-.193-4.536 1.932"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M82.553 77.92s1.877-.867 2.115-2.033c0 0-.804-.09-2.115 2.034M86.356 68.157s-.234 3.99-1.446 5.714c0 0-.417-1.177 1.446-5.714"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M87.475 68.902s-1.004 3.866-2.528 5.323c0 0-.18-1.234 2.528-5.323"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M88.742 69.954s-1.947 3.491-3.789 4.517c0 0 .137-1.24 3.789-4.517"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M90.304 71.353s-3.144 2.886-5.356 3.308c0 0 .555-1.211 5.356-3.308"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M90.995 73.09s-3.866 2-6.155 1.827c0 0 .87-1.045 6.154-1.826"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M92.183 74.206s-4.677 1.691-7.245 1.153c0 0 1.141-1.053 7.245-1.153"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M90.719 76.097s-3.972.465-5.881-.427c0 0 1.086-.616 5.88.427"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M89.448 77.82s-3.262-.736-4.521-1.97c0 0 1.027-.184 4.52 1.97"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M87.027 78.115s-1.87-.883-2.097-2.052c0 0 .805-.084 2.097 2.052"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A512E",
    d: "M85.676 83.41c.023-.18-.199-1.182-.199-1.182-.2-.621-.344-3.103-.344-3.103.002-5.303-.292-5.78-.342-6.447v-.096q.001.001-.004.047l-.003-.047-.001.096c-.056.667-.269 3.16-.218 6.444 0 0-.164 2.482-.37 3.1 0 0-.167.55-.117.856 0 0 .918-.06 1.327.33 0 0 .113.095.27.001"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M87.42 86.319h-5.228l-.576-7.197h6.382z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m87.877 80.628.12-1.506h-6.381l.121 1.506z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M88.405 79.681a.14.14 0 0 1-.138.137h-6.92a.137.137 0 0 1-.138-.137v-.895c0-.076.062-.138.138-.138h6.92c.075 0 .138.062.138.138z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB615D",
    d: "M88.405 79.029v-.243a.14.14 0 0 0-.138-.138h-6.92a.14.14 0 0 0-.138.138v.243z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m82.157 85.872.035.447h5.228l.037-.447z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.19 70.657s-.864.387-1.084.633l-.103.219s.676-.572 1.228-.66z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M96.673 68.817s-2.573-.036-2.613 1.941c0 0 1.093 1.4 2.317.121 0 0 .585-.568.927-1.22 0 0 .248-.573.646-.804 0 0-.647.071-1.277-.038"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M95.95 69.783q-.06-.002-.061-.003l.228-.126q.022.002.045.002c.368 0 1.17-.284 1.17-.284-.658.376-1.205.41-1.381.41M95.771 70.215c-.232 0-.369-.067-.438-.115l.088-.085.059-.013c.126.047.202.116.369.116q.056 0 .128-.011.076-.013.16-.013c.283 0 .613.09.613.09a5 5 0 0 0-.366-.016c-.258 0-.378.026-.378.026q-.13.021-.235.02m-.463-.136q-.03-.026-.03-.027l.027-.007q0 .02.003.034"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M95.686 70.686c-.67 0-.758-.37-.758-.37l.094-.053c.02.346.812.373 1.066.373h.078c-.187.035-.344.05-.48.05"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M95.727 71.164s-.515-.338-.738-.317c-.224.021-.417-.334-.417-.334l-.108.06s.144.297.56.386c0 0 .211-.036.703.205"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M95.868 69.743s.239-.466.904-.825c0 0-.59.473-.719.72z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M95.316 70.117q-.002 0-.008-.038l.025.02zm-.01-.072c-.004-.097.025-.286.237-.53 0 0 .145-.148.35-.546 0 0-.124.407-.298.607-.153.175-.121.275-.15.417l-.023.022z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5025",
    d: "m95.333 70.1-.025-.02-.003-.035.117-.03z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M94.906 70.277s-.343-.343.334-1.072c0 0-.548.818-.252 1.027z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.554 69.587s.012.42-.08.544c-.094.122.042.363.042.363l-.073.04s-.12-.189-.022-.464c0 0 .096-.11.133-.483"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M97.621 68.966s-2.214.717-3.56 1.792l.11.118s1.286-.968 3.45-1.91"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M96.727 71.167s-3.703 1.072-2.859 3.47c0 0 2.005.9 2.316-1.477 0 0 .314-1.748.543-1.993"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.577 73.568s.872-1.093 1.945-2.21c0 0-1.164.885-2.12 2.187 0 0-.45.744-.648 1.169l.13.06s.564-1.06.693-1.206"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m95.233 72.781.152-.177c.323-.084 1.007-.604 1.007-.604-.516.564-1.032.743-1.16.781"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m95.204 72.788.169-.18.012-.003-.152.176z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M94.898 73.34a1 1 0 0 1-.126-.011l.128-.154c.063.007.118.02.182.02a.6.6 0 0 0 .283-.08c.285-.146.797-.17.797-.17-.524.122-.74.25-.74.25a1.16 1.16 0 0 1-.524.145"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m94.772 73.329-.048-.013.065-.119.045-.028.066.006zm-.084-.025c-.026-.01-.04-.02-.04-.02l.027-.015c.003.014.01.025.013.035"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M94.869 73.895a.66.66 0 0 1-.423-.129q.028-.048.055-.088c.08.081.216.11.373.11.398 0 .915-.186.915-.186-.404.222-.705.293-.92.293"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.446 73.767a.5.5 0 0 1-.072-.07l.047-.05-.015-.006.042-.044q.017.049.053.081a1 1 0 0 0-.055.088M95.624 74.369s-.661-.184-.893-.085c-.23.097-.555-.213-.555-.213l-.094.1s.252.265.725.219c0 0 .212-.11.817-.021"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M95.221 72.564c.075-.22.25-.599.626-.991 0 0-.312.471-.453.81q-.087.088-.173.181"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M95.168 72.756s.012-.073.053-.192q.087-.093.173-.18a1 1 0 0 0-.063.199z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M94.658 73.214c-.027-.115-.032-.309.088-.59h.001c.007 0 .047-.02.121-.466 0 0 .072.242-.046.514a.54.54 0 0 0-.036.385z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.71 73.34s-.01-.01-.022-.036l.036.012zm-.035-.072a.3.3 0 0 1-.017-.054l.128-.157a1 1 0 0 1 .02.107l-.017.033z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m94.724 73.316-.036-.012q-.007-.015-.013-.036l.114-.071z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M94.319 73.687c-.096-.084-.307-.366.029-1.088 0 0-.236.82.012 1.016z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.358 73.715s-.016-.008-.04-.028l.042-.072q.022.016.046.026l-.04.043.008.013z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m94.374 73.697-.007-.013.04-.043.014.006zM93.929 73.263s.144.41.092.56c-.053.15.157.343.157.343l-.059.064s-.178-.15-.168-.45c0 0 .06-.138-.022-.517M92.696 74.79s.614.506 1.058-.076l.13.06s-.444.71-1.175.25zM92.759 76.516s.386-.193 1.225-.875l-.01.19s-.812.783-1.247.869z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M96.585 74.195s-.692-.045-1.123.18c0 0-1.256.158-1.56 1.142 0 0-.135.411-.37.45l.297.1s1.408 1.812 3.222-.762c0 0 .314-.695 1.045-.624 0 0-1.25-.504-1.51-.486"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.92 75.405s1.235-.418 2.655-.757c0 0-1.394.117-2.795.655 0 0-1.106.62-1.464.851l.471-.16c.717-.404.696-.464 1.132-.59"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M96.397 75.18c-.29 0-.49-.044-.563-.062l.21-.062c.123.035.324.046.523.046.308 0 .61-.026.61-.026-.297.08-.563.104-.78.104"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m95.834 75.118-.03-.01.228-.056.011.004q-.108.031-.209.062"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M96.562 75.69c-.507-.159-.75-.166-.75-.166-.337-.028-.522-.13-.618-.209q.08-.025.177-.057c.113.081.192.16.428.179.309.025.763.252.763.252"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m95.194 75.315-.037-.033.11-.06h.05l.054.036q-.097.032-.177.057m-.061-.059q-.025-.033-.025-.034h.028z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M95.947 76.014c-.929-.05-1.174-.384-1.238-.541q.042-.017.092-.032c.097.362 1.146.573 1.146.573"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.71 75.473q-.019-.045-.022-.068l.063-.015-.011-.012.056-.013a.2.2 0 0 0 .005.076q-.05.015-.092.031M95.464 76.522s-.486-.459-.73-.495c-.241-.035-.382-.43-.382-.43l-.126.03s.099.327.526.517c0 0 .232.019.712.378"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M95.92 74.945c.162-.132.48-.34.98-.457 0 0-.478.21-.75.401z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M95.789 75.067s.042-.05.132-.122l.228-.056a1 1 0 0 0-.143.123zM95.135 75.295q-.002 0-.002-.039l.025.026z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M95.147 75.172c.027-.101.11-.253.338-.41q-.001.001.004.002c.013 0 .072-.025.308-.3 0 0-.047.22-.268.371a.44.44 0 0 0-.203.278z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M95.266 75.222h-.13a.3.3 0 0 1 .011-.05q.09-.031.18-.059-.013.044-.031.093zM95.158 75.282l-.025-.026q0-.015.003-.034h.13z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M94.647 75.377c-.045-.101-.118-.425.506-.825 0 0-.571.519-.438.788z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.666 75.41q-.002 0-.019-.033l.068-.037a.2.2 0 0 0 .025.038l-.054.013.002.014z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.688 75.406q-.001-.015-.002-.015l.054-.013.01.013zM94.498 74.859s-.06.384-.17.473c-.113.09-.017.34-.017.34l-.08.02s-.087-.201.054-.426c0 0 .114-.078.213-.407"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M91.47 65.523s2.71 2.741.804 4.422c0 0-2.19-.19-1.302-2.416 0 0 .579-1.679.498-2.006"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M92.176 68.669s-.227-1.38-.62-2.878c0 0 .584 1.34.783 2.943 0 0 .032.87-.004 1.336l-.14-.01s.022-1.202-.02-1.392"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M91.987 67.66c-.092-.093-.455-.502-.63-1.246 0 0 .342.788.583 1.019z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m92.009 67.682-.022-.022-.047-.227.009.008zM92.243 68.386l-.035-.003.03-.024.014.026z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M92.123 68.364c-.121-.04-.31-.145-.502-.434 0 0-.127-.216-.525-.58 0 0 .436.273.613.539.134.203.247.226.377.279z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m92.17 68.376-.047-.012-.037-.196q.03.011.061.027l.026.046z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M92.111 68.912c-.212 0-.583-.124-1.01-.805 0 0 .613.706 1.009.706a.3.3 0 0 0 .08-.011c0 .03.004.066.004.103a.5.5 0 0 1-.083.007"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M92.194 68.905q-.001-.056-.004-.103a.2.2 0 0 0 .085-.045l.015.058q-.008 0-.016-.002l.016.066a.4.4 0 0 1-.096.026M90.872 68.857s.666.162.82.36c.155.198.59.085.59.085l.032.133s-.35.11-.74-.162c0 0-.13-.197-.702-.416"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M92.103 67.477q-.03-.124-.062-.242c.043-.364-.001-.928-.001-.928.138.527.104.943.063 1.17"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m92.057 67.67-.058-.23a1 1 0 0 0 .042-.205l.063.242c-.023.125-.047.193-.047.193M92.17 68.405v-.029q.022.005.038.007-.036.024-.037.022"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m92.278 68.32-.035-.2a.55.55 0 0 0 .156-.354c.03-.294.211-.47.211-.47-.166.462-.122.466-.122.466-.03.303-.13.47-.21.558"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m92.238 68.36-.065-.119v-.036q.036-.049.07-.085.019.098.035.2z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M92.208 68.383q-.016-.001-.037-.007l.002-.135.065.118z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m92.344 68.897-.002-.083c.313-.05.507-.88.507-.88-.059.794-.382.938-.505.963"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M92.298 68.903h-.001l-.007-.025.014-.006-.014-.057.023.002q.015 0 .029-.003l.002.083a.3.3 0 0 1-.046.006"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m92.29 68.878-.016-.065.016.002.014.057zM92.89 68.718s-.325.288-.353.444-.305.222-.305.222l.021.085s.228-.042.367-.31c0 0 .015-.15.27-.441M93.223 70.652s-.784.142-.888-.582l-.14-.01s.04.835.903.79zM92.85 72.372s-.288-.323-.814-1.265l-.061.178s.463 1.028.837 1.268z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M90.154 68.8s.66.214.975.583c0 0 1.11.61 1.03 1.638 0 0-.029.431.176.554l-.314-.017s-1.977 1.163-2.711-1.898c0 0-.034-.762-.74-.966 0 0 1.347-.006 1.584.106"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M91.254 70.54s-.994-.845-2.188-1.684c0 0 1.251.625 2.355 1.642 0 0 .537.592.784.94l-.117.07s-.69-.856-.834-.968"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M90.51 69.936c-.13-.016-.657-.107-1.234-.536 0 0 .736.369 1.062.4z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.54 69.94-.03-.004-.172-.136.013.001z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M90.789 70.39c-.109 0-.245-.018-.41-.068 0 0-.227-.084-.757-.124 0 0 .123-.01.283-.01.164 0 .368.011.52.058a.7.7 0 0 0 .215.036c.095 0 .165-.025.248-.045l.143.119a.8.8 0 0 1-.242.034"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m91.032 70.356-.144-.118q.03-.008.063-.015l.048.02.078.095q-.02.009-.046.018m.078-.033.01-.033.026.011q0 .002-.036.022"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M90.844 70.875c-.195 0-.447-.039-.77-.148 0 0 .329.06.66.06.253 0 .506-.036.61-.16q.029.03.065.07c-.083.076-.25.178-.565.178"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M91.409 70.697q-.035-.04-.066-.07a.2.2 0 0 0 .041-.078l.046.033-.014.006.052.038a.4.4 0 0 1-.06.07M90.333 71.378s.623-.248.862-.191c.238.056.516-.258.516-.258l.105.075s-.213.266-.681.285c0 0-.221-.069-.802.088"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m90.493 69.744-.19-.137c-.184-.28-.55-.65-.55-.65.42.294.638.604.74.787"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.57 69.905-.181-.131a1 1 0 0 0-.087-.167l.191.137c.056.1.078.16.078.16"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M91.129 70.24q-.074-.062-.146-.12a.44.44 0 0 0-.086-.334c-.149-.222-.111-.444-.111-.444.127.372.17.393.177.393h.003c.154.23.174.401.163.504"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m91.093 70.358-.016-.02.033-.015q-.015.035-.017.035m.027-.068-.121-.047-.021-.027a1 1 0 0 1 .005-.097l.146.12z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m91.078 70.338-.079-.095.121.047-.01.033z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m91.52 70.61-.05-.058c.219-.204-.118-.891-.118-.891.421.588.252.864.169.95"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m91.487 70.641-.02-.015.008-.011-.045-.033a.1.1 0 0 0 .04-.03q.023.025.05.059c-.018.02-.033.03-.033.03"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m91.468 70.626-.052-.038q.007 0 .014-.006l.045.033zM91.847 70.188s-.088.379-.016.503c.07.125-.11.321-.11.321l.066.048s.155-.152.106-.415c0 0-.076-.114-.046-.457M91.788 73.428s.653.686.763.997l.01.242s-.407-.786-.884-1.079z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M90.192 70.782s2.393.944 1.678 2.788c0 0-1.543.88-2.189-.767 0 0-.325-.748-.394-1.481 0 0-.012-.625-.293-.99 0 0 .573.313 1.198.45"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M90.55 71.974s-.61-.197-1.18-.928c0 0 .69.617 1.017.722zM90.823 72.49c-.123 0-.305-.035-.54-.18 0 0-.194-.136-.684-.293 0 0 .486.063.745.223a.54.54 0 0 0 .308.098q.043-.001.085-.003.043-.004.088-.005h.02l.048.037.05.11a.5.5 0 0 1-.12.013m.15-.021q.008-.012.016-.03l.022.015s-.013.008-.038.015"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M90.838 72.987c-.198 0-.481-.075-.869-.33 0 0 .519.235.882.235.146 0 .266-.037.317-.144l.067.084s-.112.155-.397.155"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M90.173 73.314s.605-.118.805-.014c.198.104.51-.15.51-.15l.079.095s-.246.22-.664.145c0 0-.182-.113-.73-.076"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m90.585 71.945-.134-.166c-.023-.278-.39-.94-.39-.94.479.584.524 1.106.524 1.106"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m90.952 72.501-.01-.023.031-.01q-.018.033-.02.033m.037-.062-.096-.072-.014-.03c.029-.143.095-.222.02-.442-.085-.252-.045-.676-.045-.676.039.446.118.638.118.638.102.307.057.492.017.582"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5025",
    d: "m90.942 72.478-.05-.11.097.07-.016.03z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m91.27 72.805-.058-.074c.353-.082.158-1.044.158-1.044.347.931-.1 1.118-.1 1.118"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M91.858 72.3s-.17.384-.132.532c.04.15-.178.32-.178.32l.052.066s.184-.13.198-.42c0 0-.048-.14.06-.499"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M89.257 70.56s1.776 1.504 2.613 3.01l-.148.068s-.82-1.385-2.465-3.077"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M87.917 73.23s3.839.36 3.46 2.873c0 0-1.799 1.26-2.553-1.016 0 0-.635-1.658-.907-1.856"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M90.48 75.186s-1.06-.91-2.326-1.805c0 0 1.31.65 2.494 1.75 0 0 .582.645.855 1.027l-.115.083s-.754-.936-.907-1.055"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M89.688 74.536c-.132-.013-.672-.092-1.285-.55 0 0 .77.384 1.102.406z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m89.718 74.538-.03-.002-.183-.145h.012z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "M89.96 75.037c-.104 0-.23-.016-.381-.06 0 0-.235-.084-.774-.106 0 0 .191-.027.41-.027.139 0 .288.01.406.046q.119.033.2.032c.108 0 .182-.033.268-.06q.087.067.154.126a.8.8 0 0 1-.283.05"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.243 74.988-.154-.126.065-.019.05.02.085.104q-.02.01-.046.02m.079-.04.007-.037.028.01q0 .002-.035.027"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M90.03 75.582c-.19 0-.43-.037-.734-.135 0 0 .265.042.557.042s.613-.042.724-.209q.033.034.07.076c-.082.095-.26.226-.618.226"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.647 75.356-.07-.076a.3.3 0 0 0 .037-.089l.047.035-.013.01.055.039a.3.3 0 0 1-.056.081M89.603 76.17s.615-.306.86-.253c.246.052.506-.312.506-.312l.111.08s-.198.308-.67.352c0 0-.23-.07-.807.132"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M89.659 74.32q-.104-.076-.204-.145c-.202-.307-.597-.71-.597-.71.444.314.686.655.8.855"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m89.747 74.5-.193-.141a1 1 0 0 0-.099-.184q.1.07.204.145c.063.11.088.18.088.18"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "m90.334 74.853-.155-.13c.001-.108.003-.208-.108-.37-.166-.246-.14-.497-.14-.497.151.41.195.435.203.435h.003c.17.253.202.444.197.562"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.308 74.989-.019-.023.033-.018zm.02-.078-.125-.049-.023-.029q-.002-.059-.001-.11.077.063.155.13-.001.03-.005.058"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.289 74.967-.086-.105.126.05q-.004.019-.007.036z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "m90.756 75.254-.055-.062c.208-.24-.178-1-.178-1 .466.645.312.962.233 1.062"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.723 75.29-.02-.015.006-.014-.047-.035a.2.2 0 0 0 .04-.034l.054.062c-.018.023-.033.036-.033.036"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m90.703 75.275-.055-.04.014-.009.047.034q.001 0-.006.015M91.059 74.765s-.064.43.015.567c.081.138-.09.367-.09.367l.07.051s.148-.18.082-.472c0 0-.085-.125-.077-.513M92.558 76.033s-.51.612-1.055.125l-.115.083s.569.614 1.202.025z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#225E2C",
    d: "M93.185 70.881q-.043-.01-.084-.022c-.624 2.668-1.236 6.967.594 9.079l.104-.225s-1.887-2.423-.614-8.832"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#35AB41",
    d: "M93.769 65.689s-.403.485-.464.949c0 0-.554 1.034.016 1.886 0 0 .235.36.138.56l.233-.157s2.1.105 1.153-2.878c0 0-.351-.676.093-1.174 0 0-1.042.608-1.17.814"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.847 67.718s.315-1.194.784-2.478c0 0-.624 1.128-.933 2.522 0 0-.525 2.621-.6 3.087l.008.441s.69-3.41.741-3.572"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m94.097 66.848.06-.196c.23-.183.598-.847.598-.847-.216.64-.57.968-.658 1.043"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m94.076 66.866.073-.208.007-.006-.059.196z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#25692E",
    d: "m93.92 67.455.047-.17c.12-.035.221-.047.355-.214.179-.219.584-.423.584-.423-.38.287-.509.468-.509.468-.194.237-.37.315-.477.338"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.833 67.464h-.029l.014-.023.025.023zm.043-.002.01-.119.026-.039a.4.4 0 0 1 .055-.018l-.047.168z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M93.93 67.939a.4.4 0 0 1-.13-.018l.019-.089q.048.02.103.02c.352 0 .917-.538.917-.538-.398.518-.715.625-.909.625"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.8 67.922a.4.4 0 0 1-.071-.029l.02-.056h-.015l.019-.05a.2.2 0 0 0 .066.045zM94.978 67.992s-.6.087-.752.248c-.15.16-.524.027-.524.027l-.04.114s.298.125.663-.082c0 0 .132-.163.653-.307"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M94.01 66.677a2.4 2.4 0 0 1 .153-1.024s-.084.492-.078.816z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M94.035 66.851s-.016-.063-.025-.175q.037-.106.075-.207a.8.8 0 0 0 .02.184z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#23602B",
    d: "M93.786 67.403c-.063-.084-.136-.239-.138-.508.002 0 .037-.007-.07-.42 0 0 .146.17.148.431a.48.48 0 0 0 .107.324z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.874 67.488q-.002 0-.031-.024.014 0 .033-.002zm-.056-.047-.032-.038q.023-.089.047-.173.028.036.055.08l-.003.033z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.843 67.464q-.011-.008-.025-.023l.067-.098-.01.12z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7D34",
    d: "M93.67 67.902c-.112-.04-.368-.205-.353-.885 0 0 .1.736.367.815z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "M93.722 67.914s-.02-.001-.052-.012l.014-.07q.022.006.046.006h.004l-.016.048.011.007z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C4622",
    d: "m93.729 67.893-.012-.007.017-.048.015-.001zM93.215 67.702s.263.28.274.42c.01.14.249.222.249.222l-.025.071s-.198-.056-.297-.303c0 0 0-.134-.2-.41"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M95.669 86.29H90.44l-.577-7.196h6.381z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m96.124 80.6.121-1.505h-6.38l.12 1.505z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC4641",
    d: "M96.652 79.654c0 .075-.061.137-.138.137h-6.92a.14.14 0 0 1-.137-.138v-.895c0-.076.061-.137.137-.137h6.92c.077 0 .138.061.138.137z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB615D",
    d: "M96.652 79.001v-.243a.137.137 0 0 0-.138-.137h-6.92a.136.136 0 0 0-.137.137v.243z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C3534",
    d: "m90.404 85.844.037.446h5.228l.035-.446z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    width: 3,
    height: 3,
    x: 99,
    y: 75,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.639 75.566h1.924v2.24h-1.924z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 3,
    height: 3,
    x: 99,
    y: 75,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.463 75.763c-.226.246-.885 2.106-.674 1.845.423-.52 1.344-.781 1.569-1.029a.606.606 0 0 0-.895-.816"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 3,
    height: 3,
    x: 99,
    y: 75,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.463 75.763c-.226.246-.886 2.105-.674 1.845.423-.52 1.343-.782 1.568-1.029a.605.605 0 1 0-.894-.816"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 3,
    height: 4,
    x: 99,
    y: 75,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.808 75.52-2.212-.212-.242 2.538 2.212.212z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m101.782 75.519-2.126-.203-.236 2.469 2.126.203z"
  })))))), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M98.617 74.564c.21.2 1.067 1.364.779 1.343-.5-.039-1.293-.386-1.502-.585a.524.524 0 0 1 .723-.758M98.358 75.918c.677.333 1.606 1.705 1.244 1.614-1.504-.385-1.669-.279-1.981-.483a.676.676 0 0 1-.199-.935c.204-.311.6-.363.936-.197"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M98.235 74.863s.094.04.227.116c.135.074.301.19.464.314.08.064.153.136.224.199.07.068.125.14.177.196.047.06.076.118.1.155l.036.06s-.072-.074-.174-.183c-.111-.1-.259-.235-.419-.358-.078-.062-.154-.127-.232-.182l-.204-.159zM97.974 76.373s.127.039.307.118c.182.075.411.2.635.338.11.07.214.152.314.223.097.076.177.16.252.224.069.072.114.142.15.186l.053.071-.247-.209c-.156-.114-.363-.266-.583-.4-.109-.069-.217-.142-.322-.202l-.282-.174z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M98.42 77.43c.677.335 1.605 1.707 1.244 1.615-1.504-.384-1.668-.279-1.981-.482a.675.675 0 0 1-.199-.935c.202-.312.6-.363.935-.197"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M98.036 77.887s.126.038.306.118c.18.075.411.2.634.335.112.073.214.154.316.225.096.076.176.16.25.226.07.07.114.14.152.184.034.045.052.072.052.072l-.246-.21c-.157-.114-.363-.265-.585-.4-.108-.068-.216-.142-.32-.202-.103-.062-.2-.123-.283-.174z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M98.629 79.171c.603.298 1.428 1.519 1.107 1.437-1.338-.343-1.484-.248-1.763-.428a.6.6 0 0 1-.175-.832c.18-.278.533-.323.83-.177"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M98.289 79.578s.11.034.27.104c.162.067.367.179.566.3.098.063.19.136.279.198.087.07.159.143.223.2.063.064.103.128.136.165l.047.064-.22-.185c-.14-.102-.323-.238-.52-.357-.096-.06-.19-.126-.285-.179z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M101.007 74.794c-1.256.886-1.54 1.435-1.546 1.05-.013-.891.128-1.358.307-1.7a.7.7 0 0 1 .945-.293c.342.179.609.72.294.943"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m100.628 74.083-.195.26-.201.261c-.076.093-.149.198-.225.3-.158.204-.296.418-.4.578-.09.168-.156.283-.156.283q.001-.002.024-.086c.018-.054.037-.134.075-.225.044-.087.09-.192.153-.298.067-.102.135-.213.211-.318.16-.207.329-.404.471-.538.138-.138.243-.217.243-.217"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M101.561 79.937c-1.466.46-1.906.897-1.793.528.26-.853.537-1.254.812-1.524a.7.7 0 0 1 .991.008c.27.276.359.874-.01.988"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m101.417 79.146-.264.187q-.121.085-.271.187c-.102.066-.204.144-.308.218a8 8 0 0 0-.557.428c-.137.131-.234.22-.234.22l.049-.074c.033-.045.076-.116.14-.19.069-.07.144-.156.236-.238.096-.076.195-.162.3-.237.215-.148.437-.284.612-.369a3 3 0 0 1 .297-.132M100.925 75.953l-.194.258-.2.262c-.077.093-.151.199-.227.301-.157.202-.294.418-.4.578-.09.168-.155.281-.155.281l.024-.085c.02-.053.036-.135.075-.225.045-.086.09-.192.152-.298.068-.1.137-.214.213-.319.159-.205.329-.403.47-.537.139-.137.242-.216.242-.216"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M100.463 75.763c-.226.246-.885 2.106-.674 1.845.424-.52 1.344-.781 1.569-1.028a.606.606 0 0 0-.895-.817"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m100.925 75.953-.194.258-.2.262c-.077.093-.151.199-.227.301-.157.202-.294.418-.4.578-.09.168-.155.281-.155.281l.024-.085c.02-.053.036-.135.075-.225.045-.086.09-.192.152-.298.068-.1.137-.214.213-.319.159-.205.329-.403.47-.537.139-.137.242-.216.242-.216"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M100.776 77.278c-.256.215-1.149 1.975-.904 1.744.486-.463 1.431-.603 1.686-.819a.606.606 0 1 0-.782-.925"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "m101.21 77.526-.226.232-.232.233c-.088.083-.174.178-.263.27-.182.18-.346.375-.471.522-.11.154-.19.26-.19.26l.035-.083c.025-.05.054-.129.103-.213.056-.08.113-.18.189-.277.081-.09.162-.194.252-.288.184-.183.377-.357.535-.472.155-.118.268-.184.268-.184"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M99.145 74.209s1.326 5.604.057 8.435c0 0-.053.12.152.082 0 0 1.348-2-.209-8.517"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A647",
    d: "M99.213 72.82c.12.325.213 2.058-.01 1.793-.297-.355-1.05-1.034-1.17-1.36a.627.627 0 1 1 1.18-.433"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4320",
    d: "M98.51 72.832s.07.104.16.264c.091.16.2.38.3.605.098.225.186.456.232.635.03.087.037.167.047.219l.01.084-.027-.08c-.019-.05-.043-.122-.08-.205-.072-.169-.168-.392-.27-.615-.094-.225-.194-.448-.262-.619s-.11-.288-.11-.288"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D3035",
    d: "M101.205 86.289h-3.723l-.412-4.47h4.546z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#332125",
    d: "m101.53 82.754.086-.935H97.07l.088.935z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D3035",
    d: "M101.905 82.166c0 .047-.044.086-.099.086h-4.927c-.053 0-.098-.04-.098-.086v-.555c0-.049.045-.086.098-.086h4.927c.055 0 .099.037.099.086z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#684348",
    d: "M101.905 81.76v-.15c0-.048-.044-.085-.099-.085h-4.927c-.053 0-.098.037-.098.086v.15z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#332125",
    d: "m97.456 86.012.026.277h3.723l.025-.277z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M6.115 50.032c2.08 0 3.766-1.888 3.766-4.218H2.348c0 2.33 1.686 4.218 3.767 4.218"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M13.646 50.032c2.082 0 3.768-1.888 3.768-4.218H9.881c0 2.33 1.686 4.218 3.765 4.218"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M21.18 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.533c0 2.33 1.685 4.218 3.766 4.218"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M28.713 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.533c0 2.33 1.686 4.218 3.766 4.218"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M36.246 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.534c0 2.33 1.687 4.218 3.767 4.218"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M43.779 50.032c2.079 0 3.765-1.888 3.765-4.218h-7.531c0 2.33 1.685 4.218 3.766 4.218"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M51.311 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.533c0 2.33 1.685 4.218 3.766 4.218"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M58.845 50.032c2.078 0 3.766-1.888 3.766-4.218h-7.533c0 2.33 1.685 4.218 3.767 4.218"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M66.376 50.032c2.081 0 3.767-1.888 3.767-4.218h-7.532c0 2.33 1.684 4.218 3.765 4.218"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M73.91 50.032c2.08 0 3.765-1.888 3.765-4.218h-7.532c0 2.33 1.688 4.218 3.767 4.218"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M81.442 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.534c0 2.33 1.687 4.218 3.767 4.218"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C68B",
    d: "M88.977 50.032c2.08 0 3.764-1.888 3.764-4.218h-7.532c0 2.33 1.687 4.218 3.768 4.218"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#314D37",
    d: "M96.508 50.032c2.08 0 3.767-1.888 3.767-4.218h-7.534c0 2.33 1.687 4.218 3.767 4.218"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "M13.452 32.525 2.348 45.814H9.88l9.397-13.29z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "M19.278 32.525 9.88 45.814h7.534l7.686-13.29z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m25.1 32.525-7.686 13.289h7.533l5.978-13.29z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "m30.925 32.525-5.978 13.289h7.533l4.27-13.29z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m36.75 32.525-4.27 13.289h7.533l2.562-13.29z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "m42.575 32.525-2.562 13.289h7.532l.854-13.29z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m48.4 32.525-.855 13.289h7.533l-.856-13.29z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "m54.222 32.525.856 13.289h7.532l-2.562-13.29z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m60.048 32.525 2.563 13.289h7.532l-4.27-13.29z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "m65.873 32.525 4.27 13.289h7.532l-5.978-13.29z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m71.697 32.525 5.978 13.289h7.534l-7.688-13.29z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAC2",
    d: "m77.521 32.525 7.688 13.289h7.532l-9.395-13.29z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#548D5F",
    d: "m83.346 32.525 9.395 13.289h7.534L89.17 32.524z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6,
    x: 22.159,
    y: 56.758,
    fill: "#BAE3EB",
    fillOpacity: 0.6,
    rx: 1.409
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2DCC2",
    d: "M91.324 22.665v-.607c0-.054-.123-.098-.275-.098H11.544c-.152 0-.275.044-.275.098v.607z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 35.599,
    x2: 35.291,
    y1: 71.933,
    y2: 75.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87BE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#86BD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#85BC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#83BB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#82BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#80B939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#7FB939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#7EB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#7CB739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#7BB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#7AB539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#79B539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#77B439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#76B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#74B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#73B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#73B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#71B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#70B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#6FAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#6EAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#6CAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#6BAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6AAC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#69AC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#68AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#67AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#66AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#64A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#63A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#62A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#61A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#60A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#5FA639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#5FA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#5EA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#5DA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#5CA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#5BA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5AA339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#59A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#58A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#57A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#56A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#55A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#54A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#539F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#529F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#509D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#4E9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#4C9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#4B9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#499939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#489939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#469739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#439639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#429639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#3F9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#3A9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#379039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#358E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358E39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 100.774,
    x2: 100.538,
    y1: 75.423,
    y2: 77.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#8DC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#8CC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#8AC039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#89BF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#87BE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#86BD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#84BC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#83BB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#82BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#80BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#7FB939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#7DB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#7CB739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#7BB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#7AB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#78B539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#77B439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#76B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#74B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#73B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#72B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#71B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#70B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#6EAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#6DAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#6CAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#6BAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#6AAC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#69AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#68AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#66AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#65AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#64A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#63A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#62A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#61A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#60A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#5FA639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5EA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#5DA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5CA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#5BA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#5AA339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#59A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#58A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#57A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#56A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#55A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#54A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#539F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#529F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#509E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#4C9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4B9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#499939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#489939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#479939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#469739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#449739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#439639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#429639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#429539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#3F9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3A9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#379039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#358E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358E39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.a1b484f36a5b1d25e45c1d19e13d2f76.svg";
export { ForwardRef as ReactComponent };